import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTRefundSelectedItemsNode from '../NodeGroups/DTSelectedItemTransaction/Nodes/DTRefundSelectItemsNode/DTRefundSelectedItemsNode';

const RefundSelectedItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRefundSelectedItemsNode showConfirmation={showConfirmationPage} message={'The items have been refunded.'} />
  );
};

export default RefundSelectedItemsThenSendMacro;
